import { render } from "./PropertyPerCityCard.vue?vue&type=template&id=70f3553e"
import script from "./PropertyPerCityCard.vue?vue&type=script&lang=js"
export * from "./PropertyPerCityCard.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/Pacto_console/Pacto_console/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__